import api from "./axiosInstance";

/**
 * 🔹 Get All Customers
 * GET /api/v1/customers/getAll
 */
export const getAllCustomers = () => {
  return api.get("customers/getAll");
};

/**
 * 🔹 Search Customers
 * GET /api/v1/customers/searchCustomers
 */
export const searchCustomers = (params = {}) => {
  return api.get("customers/searchCustomers", { params });
};

/**
 * 🔹 Get Customer by ID
 * GET /api/v1/customers/getById/$id
 */
export const getCustomerById = (id) => {
  return api.get(`customers/getById/${id}`);
};
